<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { tasksChart, tasks } from "./data-tasklist";
import Loader from "../components/loader";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Resumo de Chamados",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader,  },
  data() {
    return {
      updating: true,
      tasksChart: tasksChart,
      inprogressTasks: "",
      upcomingTasks: "",
      ConcluídodTasks: "",
      title: "Resumo de Chamados",
      items: [
        {
          text: "Atendimento",
          href: "/",
        },
        {
          text: "Resumo de Chamados",
          active: true,
        },
      ],
      taskList: {
        name: "",
      },
      myFiles: [],
      selected: "",
      selected2: "",
      submitted: false,
      showModal: false,
    };
  },
  validations: {
    taskList: {
      name: {
        required: helpers.withMessage("Favor preencher o campo descrição", required),
      },
    },
  },
  mounted() {
    this.isMountData();

    console.log('mounted condicoes-list_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });

  },
  methods: {
    onFileChange(event) {
      for (var i = 0; i < event.target.files.length; i++) {
        this.myFiles.push(
            require("@/assets/images/users/" + event.target.files[i].name)
        );
      }
    },

    handleSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        this.tasks.push({
          index: this.tasks.length + 1,
          taskType: this.selected,
          name: this.taskList.name,
          images: this.myFiles,
          status: this.selected2,
          checked: false,
        });
        this.isMountData();
        this.showModal = false;
        this.taskList = {};
        this.selected = "";
        this.selected2 = "";
        this.myFiles = [];
      }
      this.submitted = false;
    },

    isMountData() {
      this.tasks = tasks;
      this.inprogressTasks = tasks.filter((t) => t.taskType === "inprogress");
      this.upcomingTasks = tasks.filter((t) => t.taskType === "upcoming");
      this.ConcluídodTasks = tasks.filter((t) => t.taskType === "Concluídod");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <h4 class="card-title mb-4">Pendente Solução</h4>
              <router-link
                  to="/atendimentos/chat"
                  class="btn btn-success ms-auto"

              >Mensagens</router-link
              >
            </div>
            <b-modal title="Nova Notificação" v-model="showModal" hide-footer>
              <form @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="inputName">Descrição</label>
                      <input
                          id="inputName"
                          v-model="taskList.name"
                          type="text"
                          class="form-control"
                          placeholder="Inserir descrição"
                          :class="{
                          'is-invalid': submitted && v$.taskList.name.$error,
                        }"
                      />
                      <div
                          v-if="submitted && v$.taskList.name.$error"
                          class="invalid-feedback"
                      >
                        <span v-if="v$.taskList.name.required.$message">{{
                            v$.taskList.name.required.$message
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="file">Anexo</label>
                    <input
                        id="file"
                        type="file"
                        multiple
                        class="form-control"
                        @change="onFileChange($event)"
                    />
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      Tipo de Notificação
                      <b-form-select
                          v-model="selected"
                          class="mb-3 form-select"
                      >
                        <b-form-select-option value="upcoming"
                        >Atenção</b-form-select-option
                        >
                        <b-form-select-option value="inprogress"
                        >Comercial</b-form-select-option
                        >
                        <b-form-select-option value="Concluídod"
                        >Concluído</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      Status da Notificação
                      <b-form-select
                          v-model="selected2"
                          class="mb-3 form-select"
                      >
                        <b-form-select-option value="Aprovado"
                        >Aprovado</b-form-select-option
                        >
                        <b-form-select-option value="Atraso"
                        >Atraso</b-form-select-option
                        >
                        <b-form-select-option value="Pendente"
                        >Pendente</b-form-select-option
                        >
                        <b-form-select-option value="Concluído"
                        >Concluído</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div>
                </div>
                <div class="text-end mt-3">
                  <b-button variant="light" @click="showModal = false">Fechar</b-button>
                  <b-button type="submit" variant="success" class="ms-1"
                  >Confirmar</b-button
                  >
                </div>
              </form>
            </b-modal>
            <div class="table-responsive mb-0">
              <table class="table table-nowrap align-middle mb-0">
                <tbody>
                <tr v-for="task of upcomingTasks" :key="task.index">
                  <td style="width: 40px">
                    <b-form-checkbox
                        class="form-check"
                        v-model="task.checked"
                    >
                    </b-form-checkbox>
                  </td>
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="javascript: void(0);" class="text-dark">{{
                          task.name
                        }}</a>
                    </h5>
                  </td>
                  <td>
                    <div class="avatar-group">
                      <div
                          class="avatar-group-item"
                          v-for="(data, index) of task.images"
                          :key="index"
                      >
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              :src="`${data}`"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                        <span
                            class="badge rounded-pill font-size-11"
                            :class="{
                            'badge-soft-success': task.status === 'Concluído',
                            'badge-soft-warning': task.status === 'Pendente',
                            'badge-soft-primary': task.status === 'Aprovado',
                            'badge-soft-secondary': task.status === 'Atraso',
                          }"
                        >{{ task.status }}</span
                        >
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>




        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <h4 class="card-title mb-4">Concluído</h4>
              <b-button
                  class="btn btn-success ms-auto"
                  @click="showModal = true"
              >Mensagens</b-button
              >
            </div>
            <div class="table-responsive mb-0">
              <table class="table table-nowrap table-centered">
                <tbody>
                <tr v-for="task of inprogressTasks" :key="task.index">
                  <td style="width: 40px">
                    <b-form-checkbox
                        class="form-check"
                        v-model="task.checked"
                    >
                    </b-form-checkbox>
                  </td>
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="javascript: void(0);" class="text-dark">{{
                          task.name
                        }}</a>
                    </h5>
                  </td>
                  <td>
                    <div class="avatar-group">
                      <div
                          class="avatar-group-item"
                          v-for="(data, index) of task.images"
                          :key="index"
                      >
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              :src="`${data}`"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                        <span
                            class="badge rounded-pill font-size-11"
                            :class="{
                            'badge-soft-success': task.status === 'Concluído',
                            'badge-soft-warning': task.status === 'Pendente',
                            'badge-soft-primary': task.status === 'Aprovado',
                            'badge-soft-secondary': task.status === 'Atraso',
                          }"
                        >{{ task.status }}</span
                        >
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Resumo Semana</h4>

            <apexchart
                class="apex-charts"
                type="line"
                height="280"
                :series="tasksChart.series"
                :options="tasksChart.chartOptions"
            ></apexchart>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimas Interações de Usuários</h4>

            <div class="table-responsive">
              <table class="table table-nowrap align-middle mb-0">
                <tbody>
                <tr>
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="#" class="text-dark">Material disponível</a>
                    </h5>
                  </td>
                  <td>
                    <div class="avatar-group">
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-4.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-5.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="#" class="text-dark"
                      >Responder a aprovação de orçamento</a
                      >
                    </h5>
                  </td>
                  <td>
                    <div class="avatar-group">
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-1.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-2.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-3.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <div class="avatar-xs">
                              <span
                                  class="
                                  avatar-title
                                  rounded-circle
                                  bg-info
                                  text-white
                                  font-size-16
                                "
                              >
                                D
                              </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="#" class="text-dark"
                      >Procurar MKT, suporte técnico</a
                      >
                    </h5>
                  </td>
                  <td>
                    <div class="avatar-group">
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-8.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <img
                              src="@/assets/images/users/avatar-7.jpg"
                              alt=""
                              class="rounded-circle avatar-xs"
                          />
                        </a>
                      </div>
                      <div class="avatar-group-item">
                        <a href="javascript: void(0);" class="d-inline-block">
                          <div class="avatar-xs">
                              <span
                                  class="
                                  avatar-title
                                  rounded-circle
                                  bg-danger
                                  text-white
                                  font-size-16
                                "
                              >
                                P
                              </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table responsive -->
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
